import { render, staticRenderFns } from "./botton.vue?vue&type=template&id=7b5b2540"
import script from "./botton.vue?vue&type=script&lang=js"
export * from "./botton.vue?vue&type=script&lang=js"
import style0 from "./botton.vue?vue&type=style&index=0&id=7b5b2540&lang=less&scepod=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5b2540')) {
      api.createRecord('7b5b2540', component.options)
    } else {
      api.reload('7b5b2540', component.options)
    }
    module.hot.accept("./botton.vue?vue&type=template&id=7b5b2540", function () {
      api.rerender('7b5b2540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/bill/change_superior/form/botton.vue"
export default component.exports